import MagnifyingGlassIcon from "@heroicons/react/20/solid/MagnifyingGlassIcon";
import SparklesIcon from "@heroicons/react/20/solid/SparklesIcon";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const TabNavWrapper = styling("div")((props) => ({
  position: "sticky",
  top: "104px",
  zIndex: "10",

  backgroundColor: Color.white,
  borderBottom: "2px solid " + Color.black,

  height: "auto",

  "@media (max-width: 1279px)": {
    top: "92px",
    height: "auto",
  },
}));

export const TabNavContainer = styling("div")({
  position: "relative",
  display: "flex",

  maxWidth: "1440px",
  margin: "0 auto",
  padding: "0.75rem 28rem 0 5rem",
  
  "::after": {
    content: '""',
    position: "absolute",
    left: "5rem",
    right: "28rem",
    bottom: "-2px",
    height: "2px",
    backgroundColor: Color.backgroundGrey,
    pointerEvents: "none",
  },

  "@media (max-width: 1280px)": {
    padding: "0.75rem 0 0",
    maxWidth: "900px",
    width: "100%",

    "::after": {
      left: "0.1rem",
      right: "0.1rem",
    },
  },

  // "@media (max-width: 640px)": {
  //   justifyContent: "center",
  //   padding: "0.5rem 1rem 0rem",

  //   "::after": {
  //     left: "1rem",
  //     right: "1rem",
  //     backgroundColor: Color.backgroundGrey,
  //   },
  // },
});

export const TabNav = styling("button")((props) => ({
  borderRadius: "0.5rem 0.5rem 0 0",
  border: "none",
  borderBottom: "0px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.75rem",

  fontFamily: "Inter",
  fontSize: "1rem",
  lineHeight: "24px",
  letterSpacing: "0.1px",

  width: "100%",
  height: "56px",
  padding: "0 1rem 0",

  transition: "all 0.05s ease-in-out",

  ":hover": {
    cursor: props.$selected ? "default" : "pointer",
  },

  backgroundColor: Color.backgroundGrey,
  border: "2px solid " + Color.black,

  fontWeight: "700",

  "& > span": {
    textDecorationLine: "underline",
    textUnderlinePosition: "from-font",
  },

  padding: "0 1rem 0.25rem",

  "@media (max-width: 1279px)": {
    fontSize: "0.9rem",
    height: "auto",
    minHeight: "48px",
    width: "100%",
    padding: "0.25rem 0.5rem 0.5rem",
    alignItems: "stretch",
  },

  "@media (max-width: 640px)": {
    flexDirection: "column",
    gap: "0.75rem",
    padding: "0.75rem 0rem 0rem",
    alignItems: "stretch",
    backgroundColor: "transparent",
    border: "none",
  },
}));

export const FypIcon = styling(SparklesIcon)({
  height: "20px",
  width: "20px",

  "@media (max-width: 1279px)": {
    height: "16px",
    width: "16px",
  },
});

export const SearchIcon = styling(MagnifyingGlassIcon)({
  height: "20px",
  width: "20px",

  "@media (max-width: 1279px)": {
    height: "16px",
    width: "16px",
  },
});
